export default __webpack_public_path__ + "static/141-9ae891304f3c8d7ffea2f91f90413929.jpg";